export default __webpack_public_path__ + "c5880b4057b75e8491c41e2e5afd2516.svg";